import type { GameState } from "./types.ts";

const BASIS_POINTS = 10_000n;

export function confirmedTapProduction(state: Pick<GameState, "progress">): bigint {
  const primary = BigInt(state.progress.primaryProduced);
  const passive = BigInt(state.progress.passiveProduced);
  return primary > passive ? primary - passive : 0n;
}

export function quoteTapProductionGrant(tapProduction: bigint, grantBasisPoints: number): bigint {
  if (tapProduction < 0n) throw new Error("tap production must be non-negative");
  if (!Number.isSafeInteger(grantBasisPoints) || grantBasisPoints < 0) {
    throw new Error("grant basis points must be a non-negative integer");
  }
  return (tapProduction * BigInt(grantBasisPoints)) / BASIS_POINTS;
}
